export default "__VITE_ASSET__CyYHvfNW__"